<script setup lang="ts">
import { FaqProps } from "./Faq.props"

withDefaults(defineProps<FaqProps>(), {
  theme: ""
})
</script>

<template>
  <div
    class="faq-wrapper flex flex-col items-start gap-4 px-4 pb-8 pt-4"
    :class="{ 'bg-grey-main md:rounded-lg': theme === 'grey' }"
    v-if="questions"
  >
    <div class="flex items-center gap-2 text-green-main">
      <UtilsIcon name="QuestionMarkCircle.svg" class="h-6 w-6" />

      <p class="pig-bold">
        {{ label ? label : $t("contact.faq.frequentlyQuestion") }}
      </p>
    </div>

    <UtilsButton
      v-for="({ text, path }, index) in questions"
      :key="`question-${index}`"
      :text="text"
      :path="path"
      theme="link-black"
      class="custom-btn-no-padding custom-btn-beaver custom-btn-whitespace"
    />
  </div>
</template>
